import React from 'react';

export const QuestionIcon = ({ color = '#774C9E' }) => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7656 18.4941V18.5041M8.76562 10.4941C8.76562 8.285 10.5565 6.49414 12.7656 6.49414C14.9748 6.49414 16.7656 8.285 16.7656 10.4941C16.7656 12.3616 15.4859 13.9302 13.7555 14.3707C13.2203 14.507 12.7656 14.9419 12.7656 15.4941M23.7656 12.4941C23.7656 18.5693 18.8408 23.4941 12.7656 23.4941C6.69049 23.4941 1.76562 18.5693 1.76562 12.4941C1.76562 6.41901 6.69049 1.49414 12.7656 1.49414C18.8408 1.49414 23.7656 6.41901 23.7656 12.4941Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
